// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/icon-template/src/index.tsx

import { baseIcon, defaultIconGroupProps } from '@bubble-ui/temp-icon-base';
import { isWaffle, isWhiteLabel } from '@bubble-ui/particle-design-versions';
var IconErrorPathPancake = 'M0 10C0 4.486 4.486 0 10 0s10 4.486 10 10-4.486 10-10 10S0 15.514 0 10Zm2 0c0 4.411 3.589 8 8 8s8-3.589 8-8-3.589-8-8-8-8 3.589-8 8Zm9 .5v-5H9v5h2ZM8.5 13a1.5 1.5 0 1 1 3.001.001A1.5 1.5 0 0 1 8.5 13Z';
var IconErrorPathWaffle = 'M10.833 10.833H9.167v-6h1.666v6ZM10 15a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5ZM.833 10C.833 4.945 4.945.833 10 .833S19.167 4.945 19.167 10 15.054 19.167 10 19.167C4.945 19.167.833 15.054.833 10ZM2.5 10c0 4.136 3.365 7.5 7.5 7.5s7.5-3.364 7.5-7.5-3.365-7.5-7.5-7.5S2.5 5.864 2.5 10Z';
var IconErrorPathWaffleFilled = 'M9.993 19.16c5.059 0 9.167-4.108 9.167-9.167 0-5.058-4.108-9.166-9.167-9.166C4.935.827.827 4.935.827 9.993c0 5.059 4.108 9.167 9.166 9.167ZM9.16 4.827h1.667v6H9.16v-6Zm.833 7.666c.692 0 1.25.559 1.25 1.25 0 .692-.558 1.25-1.25 1.25-.691 0-1.25-.558-1.25-1.25 0-.691.559-1.25 1.25-1.25Z';
var IconErrorPathWhiteLabel = 'M9.994 14.169a.879.879 0 0 0 .639-.256.85.85 0 0 0 .26-.633.888.888 0 0 0-.255-.642.847.847 0 0 0-.633-.263.872.872 0 0 0-.639.259.863.863 0 0 0-.261.637c0 .252.085.464.255.638.17.173.382.26.634.26Zm-.86-3.16h1.73V5.895h-1.73v5.114Zm.871 7.16a7.984 7.984 0 0 1-3.18-.638 8.232 8.232 0 0 1-2.604-1.754 8.233 8.233 0 0 1-1.753-2.603A7.992 7.992 0 0 1 1.83 9.99c0-1.131.213-2.19.638-3.175a8.234 8.234 0 0 1 4.357-4.347 7.992 7.992 0 0 1 3.184-.638 7.93 7.93 0 0 1 3.175.638A8.248 8.248 0 0 1 17.53 6.82c.425.988.638 2.046.638 3.174a7.984 7.984 0 0 1-.638 3.18 8.23 8.23 0 0 1-1.754 2.603 8.249 8.249 0 0 1-2.598 1.754 7.943 7.943 0 0 1-3.174.638ZM10 16.439c1.793 0 3.314-.625 4.565-1.875 1.25-1.25 1.875-2.772 1.875-4.565 0-1.792-.625-3.313-1.875-4.564-1.251-1.25-2.772-1.876-4.565-1.876-1.792 0-3.313.626-4.564 1.876S3.559 8.207 3.559 10c0 1.793.625 3.314 1.876 4.565 1.25 1.25 2.772 1.876 4.564 1.876Z';
var IconErrorPathWhiteLabelFilled = 'M9.994 14.169a.879.879 0 0 0 .639-.256.85.85 0 0 0 .26-.633.888.888 0 0 0-.255-.642.847.847 0 0 0-.633-.263.872.872 0 0 0-.639.259.863.863 0 0 0-.261.637c0 .252.085.464.255.638.17.173.382.26.634.26Zm-.86-3.16h1.73V5.895h-1.73v5.114Zm.871 7.16a7.984 7.984 0 0 1-3.18-.638 8.232 8.232 0 0 1-2.604-1.754 8.233 8.233 0 0 1-1.753-2.603A7.992 7.992 0 0 1 1.83 9.99c0-1.131.213-2.19.638-3.175a8.234 8.234 0 0 1 4.357-4.347 7.992 7.992 0 0 1 3.184-.638 7.93 7.93 0 0 1 3.175.638A8.248 8.248 0 0 1 17.53 6.82c.425.988.638 2.046.638 3.174a7.984 7.984 0 0 1-.638 3.18 8.23 8.23 0 0 1-1.754 2.603 8.249 8.249 0 0 1-2.598 1.754 7.943 7.943 0 0 1-3.174.638Z';
var IconErrorViewBoxWaffle = {
  viewBoxWidth: 20,
  viewBoxHeight: 20
};
var IconErrorViewBoxWaffleFilled = {
  viewBoxWidth: 20,
  viewBoxHeight: 20
};
var IconErrorViewBoxWhiteLabel = {
  viewBoxWidth: 20,
  viewBoxHeight: 20
};
var IconErrorViewBoxWhiteLabelFilled = {
  viewBoxWidth: 20,
  viewBoxHeight: 20
};
export var IconError = baseIcon('IconError', {
  groupProps: defaultIconGroupProps,
  getPath: _ref => {
    var {
      designVersion,
      filled
    } = _ref;
    return isWhiteLabel(designVersion) ? filled ? IconErrorPathWhiteLabelFilled : IconErrorPathWhiteLabel : isWaffle(designVersion) ? filled ? IconErrorPathWaffleFilled : IconErrorPathWaffle : IconErrorPathPancake;
  },
  shapeSize: _ref2 => {
    var {
      designVersion,
      filled
    } = _ref2;
    return isWhiteLabel(designVersion) ? filled ? IconErrorViewBoxWhiteLabelFilled : IconErrorViewBoxWhiteLabel : isWaffle(designVersion) ? filled ? IconErrorViewBoxWaffleFilled : IconErrorViewBoxWaffle : {};
  }
});
//# sourceMappingURL=index.js.map